import {
  GET_UNVERIFIED_FAILURE,
  GET_UNVERIFIED_REQUEST,
  GET_UNVERIFIED_SUCCESS,
} from '../actions/unverified';

const initialState = {
  list: {
    isFetching: false,
    items: null,
    meta: {
      totalItems: 0,
      itemCount: 0,
      itemsPerPage: 0,
      totalPages: 0,
      currentPage: 0,
    },
  },
};

const unverifiedReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_UNVERIFIED_REQUEST:
      return {
        ...state,
        list: {
          ...state.list,
          isFetching: true,
        }
      };
    case GET_UNVERIFIED_FAILURE:
      return {
        ...state,
        list: {
          ...state.list,
          isFetching: false,
        }
      };
    case GET_UNVERIFIED_SUCCESS:
      return {
        ...state,
        list: {
          ...state.list,
          ...action.payload,
          isFetching: false,
        }
      };
    default:
      return state;
  }
};

export default unverifiedReducer;
